require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/registrer/account/myReturnsModule.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/registrer/account/myReturnsModule.legacy.js
// module id = 740
// module chunks = 31